import React, { useEffect, useRef, useState } from "react";
import { useExport } from "../../context/ExportContext";
import { reportCenterExportPolling } from "../../service/api";
import { downloadFile } from "../../utils/downloadFile";
import styles from "./index.module.css";
import { MdDragIndicator } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";

const Loader = () => (
  <div
    style={{
      width: 18,
      height: 18,
      border: "2px solid rgba(255,255,255,0.2)",
      borderTop: "2px solid #fff",
      borderRadius: "50%",
      animation: "spin 0.9s linear infinite",
      //   marginBottom: 6,
    }}
  />
);

export const ExportManager = () => {
  const { jobs, updateJob, removeJob } = useExport();
  const panelRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({
    // in top middle
    x: window.innerWidth/2 - 130,
    y: 12,
    
    // at top right
    // x: window.innerWidth - 260,
    // y: 6,

    // at bottom right
    // x: window.innerWidth - 280,
    // y: window.innerHeight - 60,
  });
  const [dragging, setDragging] = useState(false);
  const dragStart = useRef({ x: 0, y: 0 });

  const onMouseDown = (e) => {
    setDragging(true);
    dragStart.current = {
      x: e.clientX - pos.x,
      y: e.clientY - pos.y,
    };
  };

  const onMouseMove = (e) => {
    if (!dragging) return;

    setPos({
      x: e.clientX - dragStart.current.x,
      y: e.clientY - dragStart.current.y,
    });
  };

  const onMouseUp = () => setDragging(false);

  const exportAssetPolling = async (id) => {
    try {
      const res = await reportCenterExportPolling(id);
      console.log("res", res);

      if (!res.data?.exists && !res.data?.fileUrl)
        throw new Error("Job not found");

      if (res.data?.fileUrl) {
        downloadFile(res.data?.fileUrl);
        removeJob(id);
        return;
      }

      if (!res.data?.isRunning) throw new Error("Job is not running");
    } catch (err) {
      console.log("exportPolling err", err);
      removeJob(id);
    }
  };

  useEffect(() => {
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      window.removeEventListener("mouseup", onMouseUp);
    };
  });

  useEffect(() => {
    const interval = setInterval(async () => {
      for (const job of jobs) {
        exportAssetPolling(job.id);
      }
    }, 10000); // 10s polling

    return () => clearInterval(interval);
  }, [jobs, updateJob]);

  if (!jobs.length) return null;

  return (
    <div
      ref={panelRef}
      className={styles.exportPanel}
      style={{
        position: "fixed",
        left: pos.x,
        top: pos.y,
        width: 240,
        backdropFilter: "blur(8px)",
        background: "rgba(60, 60, 60, 0.5)",
        border: "1px solid rgba(255,255,255,0.15)",
        boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
        color: "#fff",
        padding: "4px 12px",
        borderRadius: 14,
        zIndex: 2000,
        cursor: dragging ? "grabbing" : "default",
      }}
    >
      {/* Header (Draggable Handle) */}
      <div
        style={{
          fontWeight: 600,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "8px 0"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          <IoIosArrowDown
            size={16}
            onClick={() => setOpen(!open)}
            style={{
              cursor: "pointer",
              transition: "transform 250ms ease",
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
            }}
          />

          <span style={{ marginTop: "2px" }}>File Exports</span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          {!open && <Loader />}

          <MdDragIndicator
            onMouseDown={onMouseDown}
            style={{
              cursor: "grab",
            }}
            size={24}
          />
        </div>
      </div>

      {/* Jobs */}

      {open &&
        jobs.map((job) => (
          <div
            key={job.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 4px",
              borderBottom: "1px solid rgba(255,255,255,0.1)",
              fontSize: ".9rem",
            }}
          >
            <div style={{ fontWeight: 500 }}>{job.name}</div>
            <Loader />
          </div>
        ))}
    </div>
  );
};
